<template>
    <main-toolbar >
        <div class="sales-select-box-wrapper">
            <search-select-auto-complete
                :items="options.rentalcompanyId"
                :label="'업체번호' | translate"
                class="sales-select-box-style"
                v-model="innerSelectOptions.rentalcompanyId"
            />
            <select-box-single-check
                :items="options.useYn"
                :label="'사용여부' | translate"
                class="sales-select-box-style"
                v-model="innerSelectOptions.useYn"
            />
            <select-box-single-check
                :items="options.deleteYn"
                :label="'삭제여부' | translate"
                class="sales-select-box-style"
                v-model="innerSelectOptions.deleteYn"
            />
            <select-box-single-check
                :items="options.deviceType"
                :label="'장치유형' | translate"
                class="sales-select-box-style"
                v-model="innerSelectOptions.deviceType"
            />
            <select-box-single-check
                :items="options.installStatus"
                :label="'출고여부' | translate"
                class="sales-select-box-style"
                v-model="innerSelectOptions.installStatus"
            />

        </div>
    </main-toolbar>
</template>

<script>
/**
 * 장치 목록에서 필터 부분입니다.
 */
import MainToolbar from "@/components/common/layout/MainToolbar";
import SelectBoxSingleCheck from "@/components/selectBox/SelectBoxSingleCheck";
import {PATH} from "@/constants";
import SearchSelectAutoComplete from "@/components/selectBox/SearchSelectAutoComplete";
import selectOptions from "@/components/selectBox/selectOptions";

export default {
    name: "SelectBoxFilterGroup",
    components:{
        MainToolbar,
        SelectBoxSingleCheck,
        SearchSelectAutoComplete
    },
    data() {
        return{
            options:{
                rentalcompanyId:[],
                useYn:selectOptions.DEVICE_LIST.USE_YN,
                deleteYn:selectOptions.DEVICE_LIST.DELETE_YN,
                deviceType:selectOptions.DEVICE_LIST.DEVICE_TYPE,
                installStatus:selectOptions.DEVICE_LIST.INSTALL_STATUS
            },
            innerSelectOptions: undefined,
        }
    },
    props: {
        selectOptions:{
            type:Object,
            default:()=>{}
        },
    },


    watch: {
        selectOptions:{
            deep:true,
            immediate: true,
            handler(newValue) {
                this.innerSelectOptions = newValue
            }
        },
        innerSelectOptions: {
            deep: true,
            immediate: true,
            handler(newValue){
                this.$emit('update-select-options',newValue)
            }
        },

    },
    methods :{
        async loadCompanyOptions() {
            const res = await this.$request(PATH.MEMBERSHIP.LIST)
                .get()
                .catch(e => {
                    alert('조회실패')
                })
                .enqueue()
            const companyArr = res.data.map((
                {rentalcompany_id, rentalcompany_name}) => {
                return {codeKey: rentalcompany_id, codeValue: `${rentalcompany_name} [${rentalcompany_id}]`}
            })
            this.options.rentalcompanyId = [...companyArr];
        },
    },
    created() {
        this.loadCompanyOptions();//업체번호
    },
}
</script>

<style scoped>
.sales-select-box-wrapper{
    display: flex;
    height: 100%;

}
.sales-select-box-style{
    width: 180px;
    margin: 2px
}
.main-toolbar[data-v-6772237e]{
    margin-bottom:0px
}

>>> .v-input__control{
    width: 10px;
    height: 10px;
}
/* Select Box 에서 height부분 */
>>> .v-input__control .v-input__slot  fieldset{
    height: 47px;
}
/* Select Box 에서 X 아이콘 font 부분 */
>>> .v-input__control  .v-input__slot  .v-select__slot  .v-input__append-inner .v-icon {
    font-size: 19px;
}

/* Select Box 에서 label font 부분 */
>>> .v-input__control  .v-input__slot  .v-select__slot  .v-label {
    font-size: 12px;
}
/* Month Select Box 에서 label font 부분 */
>>> .v-input__control  .v-input__slot  .v-text-field__slot  .v-label {
    font-size: 12px;
}

>>> .v-input__control  .v-input__slot  .v-select__slot  .v-select__selections {
    padding: 0;
}
/*single Select Box 에서 font 부분 */
>>> .v-input__control  .v-input__slot  .v-select__slot  .v-select__selections .v-select__selection {
    font-size: 12px;
    margin: 0;
}
/*Multi Select Box 에서 font 부분 */
>>> .v-input__control  .v-input__slot  .v-select__slot  .v-select__selections .text-truncate {
    font-size: 12px;
    margin: 0;
}
/*SearchSelectBox 에서 font 부분입니다.*/
>>> .v-select.v-text-field input {
    font-size: 12px !important;
    margin: 0 !important;
}
</style>